import React, {FC} from "react";
import { Typography, Box, makeStyles, Grid, Button } from "@material-ui/core";
import {useTheme} from "@material-ui/core/styles";

interface Props {
    id: any,
    title: string,
    date: string,
    setSelectedRecord: any,
    setOpenModal: any,
    styles?: any
}

const useStyle = makeStyles(() => ({
    itemContainer: {
        padding: "20px 0",
    },
    textSecondary: {
        marginTop: "10px",
        fontSize: 18
    },
    button: {
        padding: "12px 44px"
    }
}));

const NotesListItem: FC<Props> = ({id, title, date, setSelectedRecord, setOpenModal, styles} : Props) => {
    const classes = useStyle();
    const theme = useTheme();

    return (
        <Grid container justify="center" alignItems="center" className={`${classes.itemContainer} ${styles}`}>
            <Grid item xs={12} sm={9}>
                <Box>
                    <Typography variant="h4">{title}</Typography>
                    <Typography color="textSecondary" className={classes.textSecondary}>{date}</Typography>
                </Box>
            </Grid>
            <Grid item container justify="flex-end" xs={12} sm={3}>
                <Button type="button" variant="contained" color="primary"
                    className={classes.button}
                    onClick={() => {
                        setOpenModal(true);
                        setSelectedRecord(id, title, date);
                    }}
                >
                    View
                </Button>
            </Grid>
        </Grid>
    );
};

export default NotesListItem;
